import React, { Component, Suspense } from "react"
import { Container, Col, Button, Row } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom'
import i18n from 'i18next'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import axios from "axios"
import kitBiobakeryRG from "../images/details/kit-consult.png"
import consultingReport from "../images/details/consultation-rapport.png"
import kitBiobakery from "../images/details/kit_biobakery_rg.png"


const WaitingDiv = React.lazy(() => import('../components/waiting'));

class ProductsPage extends Component {

  constructor(props) {
    super(props);
    const t = this.props.t;
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined;
    this.langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : "";
    this.productUrlMap = {
      1: `${this.langSubPath}/${t("path|details-produit")}/kit-nahibu`,
      2: `${this.langSubPath}/${t("path|details-produit")}/kit-nahibu-expert`,
      9: `${this.langSubPath}/${t("path|details-produit")}/consultation`,
    };
    this.state = {
      redirect: null,
      redirectState: {},
    }
    this.handleClick = this.handleClick.bind(this)

  }

  addItemToCart(event, quantity, coupon) {
    const t = this.props.t

    let products = []
    let kit_consult_skus = this.props.config.products.kit_biobakery_rg_consult.skus
    let probioform_id = this.props.config.products.coaching_6_mois.skus
    let probioform_plus_id = this.props.config.products.coaching_1_an.skus

    const selectedProductSku = event.target.getAttribute('sku')

    if (kit_consult_skus.includes(selectedProductSku)) {
      products = [
        {
          productSkus: this.props.config.products.kit_biobakery_rg.skus[0],
          quantity: 1,
        },
        {
          productSkus: this.props.config.products.consultation_solo.skus[0],
          quantity: 1,
        },
      ]
    } else if (probioform_id.includes(selectedProductSku)) {
      products = [
        {
          productSkus: this.props.config.products.kit_biobakery_rg.skus[0],
          quantity: 1,
        },
        {
          productSkus: this.props.config.products.consultation_solo.skus[0],
          quantity: 2,
        },
        {
          productSkus: this.props.config.products.probiotique.skus[0],
          quantity: 3,
        }
      ]
    } else if (probioform_plus_id.includes(selectedProductSku)) {
      products = [
        {
          productSkus: this.props.config.products.kit_biobakery_rg.skus[0],
          quantity: 2,
        },
        {
          productSkus: this.props.config.products.consultation_solo.skus[0],
          quantity: 4,
        },
        {
          productSkus: this.props.config.products.probiotique.skus[0],
          quantity: 6,
        }
      ]
    } else {
      products = [
        {
          productSkus: selectedProductSku,
          quantity: quantity,
        },
      ]
    }
    // Redirect to cart
    this.setState({
      redirect: this.langSubPath + "/" + t("path|panier") + "/",
      redirectState: {
        products: products,
        coupon: coupon,
      }
    })
  }

  getCoupon(offer) {
    if (offer === "lite") {
      return null
    }
    if (offer === "premium") {
      return null
    }
    if (offer === "ultra") {
      return null
    }
    if (offer === "coaching") {
      return null
    }
    return null
  }



  backToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  handleClick(event, quantity, coupon) {

    // add item to cart and redirect to cart page
    this.addItemToCart(event, quantity, coupon)

    if (this.props.auth.logged) {
      const data = {
        email: this.props.auth.user.email,
        sendinblue_list: "Abandon panier"
      }

      const requestUrl = this.props.config.wooApiUrl + "/register-list"
      axios.post(requestUrl, data).then(response => {
        this.setState({
          email: "",
          success: true,
          error: false,
          waiting: false,
        })
      }).catch(error => {
        // manage errors
        if (error.response) {
          console.error("Response error", error.response.data.data.message)
        } else if (error.request) {
          console.error("Request error", error.request)
        } else {
          console.error("Error", error.message)
        }

        this.setState({
          success: false,
          error: true,
          waiting: false,
        })
      })
      event.preventDefault()
    }

  }

  render() {
    const t = this.props.t

    if (this.state.redirect) {
      return <Redirect to={{
        pathname: this.state.redirect,
        state: this.state.redirectState,
      }} />
    }

    if (this.props.waitingStore) {
      return (<Suspense fallback={<div></div>}><WaitingDiv center={true} waiting={this.props.waitingStore} /></Suspense>)
    }
    return (
      <>


        <Container className="my-md-5 my-2 py-5">
          <h1 className="second-title dark-blue mb-5">{t("nos-produits|Nos produits")}</h1>
          <Row>
            <Col md={4} sm={12} className="mt-4 d-flex flex-column justify-content-between" >
              <Link className="pl-0 pb-0 w-100 nav-link h-100 hover-opacity rounded" to={this.productUrlMap[1]}>
                <div className="w-100 center">
                  <LazyLoadImage alt={t("buy|Kit d'analyse du microbiote intestinal Nahibu")} src={kitBiobakery} width="60%" />
                </div>

                <p className="pt-2 mb-0 dark-blue"><b>{t("nos-produits|KIT NAHIBU")}</b></p>
                <p className="dark-blue mt-0">{t("nos-produits|Test du microbiote intestinal")}</p>
              </Link><Button
                onClick={(e) => this.handleClick(e, 1, null)}
                sku={this.props.config.products.kit_biobakery_rg.skus[0]}
                className="mt-auto font-weight-light btn-pricing-slider w-100 d-flex justify-content-between btn-hover"
              >
                <div
                  onClick={(e) => this.handleClick(e, 1, null)}
                  sku={this.props.config.products.kit_biobakery_rg.skus[0]}
                >
                  {t("nos-produits|Ajouter au panier")}
                </div>
                <div
                  onClick={(e) => this.handleClick(e, 1, null)}
                  sku={this.props.config.products.kit_biobakery_rg.skus[0]}
                  className="pricing-container"
                >
                  <span className="current-price">199.00€</span>
                  <span className="old-price">249.00€</span>
                </div>
              </Button>
            </Col>

            <Col md={4} sm={12} className="mt-4 d-flex flex-column justify-content-between" >
              <Link className="pl-0 pb-0 w-100 nav-link h-100 hover-opacity rounded" to={this.productUrlMap[2]}>
                <div className="w-100 center">
                  <LazyLoadImage alt={t("nos-produits|Kit d'analyse du microbiote intestinal Nahibu + consultation")} src={kitBiobakeryRG} width="60%" />
                </div>

                <p className="pt-2 mb-0 dark-blue"><b>{t("nos-produits|KIT NAHIBU EXPERT")}</b></p>

                <p className="dark-blue mt-0">{t("nos-produits|Test du microbiote intestinal + Consultation")}</p>
              </Link>

              <Button onClick={(e) => this.handleClick(e, 1, null)} sku={this.props.config.products.kit_biobakery_rg_consult.skus[0]} className="mt-auto font-weight-light btn-pricing-slider w-100 d-flex justify-content-between btn-hover">
                <div onClick={(e) => this.handleClick(e, 1, null)} sku={this.props.config.products.kit_biobakery_rg_consult.skus[0]} >
                  {t("nos-produits|Ajouter au panier")}
                </div>
                <div onClick={(e) => this.handleClick(e, 1, null)} sku={this.props.config.products.kit_biobakery_rg_consult.skus[0]} className="pricing-container">
                  <span className="current-price">249.00€</span>
                  <span className="old-price">299.00€</span>
                </div>
              </Button>
            </Col>

            <Col md={4} sm={12} className="mt-4 d-flex flex-column justify-content-between" >
              <Link className="pl-0 pb-0 w-100 nav-link h-100 hover-opacity rounded" to={this.productUrlMap[9]}>
                <div className="w-100 center">
                  <LazyLoadImage alt={t("nos-produits|Consultation seule")} src={consultingReport} width="54.5%" />
                </div>
                <p className="pt-2 mb-0 dark-blue"><b>{t("nos-produits|CONSULTATION")}</b></p>
                <p className="dark-blue mt-0">{t("nos-produits|Consultation avec un expert")}</p>
              </Link>
              <Button onClick={(e) => this.handleClick(e, 1, null)} sku={this.props.config.products.consultation_solo.skus[0]} className="mt-auto font-weight-light btn-pricing-slider w-100 d-flex justify-content-between btn-hover"><div onClick={(e) => this.handleClick(e, 1, null)} sku={this.props.config.products.consultation_solo.skus[0]}>{t("nos-produits|Ajouter au panier")}</div><div onClick={(e) => this.handleClick(e, 1, null)} sku={this.props.config.products.consultation_solo.skus[0]}><span class="current-price">50.00€</span></div></Button>
            </Col>

          </Row>
        </Container>
      </>
    )
  }
}
export default withTranslation()(ProductsPage)
